<script setup lang="ts">
import type { ValidationFn } from '@idem/tipos/validation-fn';

const { validator } = defineProps<{
  validator: ValidationFn | undefined;
}>();
const emit = defineEmits(['error']);

const validar = validator
  ? e => {
      const result = validator({ value: e.target.value });
      if (result.code) {
        emit('error', `${result.code}`, result);
      }
    }
  : () => {};

const handleUpdate = next => e => {
  next(e);
  validar(e);
};
</script>

<template><slot :validar="handleUpdate"></slot></template>

<style scoped></style>
